import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ConfigService } from './core/services/config.service';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { provideNgxMask } from 'ngx-mask';
import { provideEnvironmentNgxMask } from 'ngx-mask';

import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { SessionAuthInterceptor } from './auth/interceptors/session-auth.interceptor';

export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: SessionAuthInterceptor, multi: true
    },
    [
      provideNgxMask(),
      provideEnvironmentNgxMask({
        thousandSeparator: '.'
      })
    ]
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
